export const CROSS_APPLICATION_FORM_COOKIE = 'AF1' as const
export const LOCAL_APPLICATION_FORM_COOKIE = 'AF2' as const
export const NEW_CROSS_APPLICATION_FORM_COOKIE = 'AF3' as const
export const COOKIE_CONSENT = 'COOKIE_CONSENT' as const